import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useContext } from 'react';
import { LazySuspense } from 'react-loosely-lazy';
import { PeopleMenuContext } from '../../context/PeopleMenuContext';
import useBrowsePeoplePermission from '../../hooks/useBrowsePeoplePermission';
import { VOID_FUNC } from '../../utils/constants';
import { MenuContent, MenuContentFallback } from '../MenuContent/lazy';
import PeopleMenuProviders from './PeopleMenuProviders';
const stopPropagation = e => e.stopPropagation();
export const PeopleMenuContentInternal = /*#__PURE__*/memo(() => {
  const {
    isBrowseUsersEnabled
  } = useContext(PeopleMenuContext);
  const {
    loading: isLoadingPermission,
    hasPermission
  } = useBrowsePeoplePermission(isBrowseUsersEnabled);
  return /*#__PURE__*/React.createElement("span", {
    onClick: stopPropagation
  }, /*#__PURE__*/React.createElement(LazySuspense, {
    fallback: /*#__PURE__*/React.createElement(MenuContentFallback, null)
  }, /*#__PURE__*/React.createElement(MenuContent, {
    isLoadingPermission: isLoadingPermission,
    hasPermission: hasPermission
  })));
});
const PeopleMenuContent = props => {
  return /*#__PURE__*/React.createElement(PeopleMenuProviders, _extends({
    isOpen: true,
    onOpen: VOID_FUNC,
    onClose: VOID_FUNC
  }, props), /*#__PURE__*/React.createElement(PeopleMenuContentInternal, null));
};
export default PeopleMenuContent;